import { SetHeaderService } from "@/helper/userHelper";
import service from "@/service/baseHttpService";
import {
  GetCreateExpenseFromEWFRequest,
  GetCreateExpenseFromPayRunRequest,
  GetCreateExpenseFromSSORequest,
  GetPaidExpenseFromPayrollRequest,
} from "@/service/expense/expenseFacade";

class ExpenseService {
  DoCreateExpenseFromPayRun(input: any) {
    const _input = GetCreateExpenseFromPayRunRequest(input);

    return service.peakRealTimeAPI
      .post("/api/Invoice/CreateExpenseFromPayRun", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoPaidExpenseFromPayroll(input: any) {
    const _input = GetPaidExpenseFromPayrollRequest(input);

    return service.peakRealTimeAPI
      .post("/api/Payment/PaidExpenseFromPayroll", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoCreateExpenseFromSSO(input: any) {
    const _input = GetCreateExpenseFromSSORequest(input);

    return service.peakRealTimeAPI.post("/api/Invoice/CreateExpenseFromSSO", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoCreateExpenseFromEWF(input: any) {
    const _input = GetCreateExpenseFromEWFRequest(input);

    return service.peakRealTimeAPI.post("/api/Invoice/CreateExpenseFromEWF", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new ExpenseService();
